const mainUnits = {
  percentage: "percentage",
  total: "total",
  rating: "rating",
} as const;

const secondaryUnits = {
  percentage: "percentage",
  none: "none",
  total: "total",
  average: "average",
  evolution: "evolution",
} as const;

export const Unit = {
  ...mainUnits,
  ...secondaryUnits,
};

export type MainUnit = typeof mainUnits[keyof typeof mainUnits];
export type SecondaryUnit = typeof secondaryUnits[keyof typeof secondaryUnits];
export type DataUnit = MainUnit & SecondaryUnit;
